class StoreLocator {
    constructor (parent) {
      if (!parent) {
        return;
      }
      this.parent = parent;
      this.ipAddress = {};
      this.storeData = {};
      this.init();
    }
  
    fetchUserLocation = async () => {
      let url = "https://ipinfo.io/json";
      let response = await fetch(url);
      response = await response.json();
      this.ipAddress = response;
    }
  
    fetchStores = async () => {
      let parent = this.parent;
      let url = parent.dataset.id;
      if (!url) {
        return;
      }
      let res = await fetch(url);
      let resData = await res.json();
      this.storeData = resData;
      this.renderData(resData);
    }
  
    renderData = (data) => {
      if (!data) {
        return;
      }
      let parent = this.parent;
      let currentCity = '';
      if (this.ipAddress != {}) {
        currentCity = this.ipAddress.city;
      }
      let nearStores = '';
      let otherStores = '';
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (currentCity.toLocaleLowerCase() == element.city.toLocaleLowerCase()) {
          nearStores += this.blockHtml(element);
        } else {
          otherStores += this.blockHtml(element);
        }
      }
      let allStores = nearStores + otherStores;
      let storeWrapper = qs('.stores-js', parent);
      storeWrapper.innerHTML = allStores;
    }
  
    clickEvent = () => {
      let parent = this.parent;
      let searchBtn = qs('.search-location-btn-js', parent);
      searchBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        let that = e.currentTarget;
        let filterWrapper = that.closest('filter-wrapper');
        let input = qs('#location', filterWrapper);
        if (input.value == '') {
          this.renderData(this.storeData);
        } else {
          this.renderFilterData(input.value);
        }
      })
    }
  
    renderFilterData = (data) => {
      if (!data) {
        return;
      }
      let parent = this.parent;
      let storeData = this.storeData;
      let storeHtml = '';
      let value = data.toLocaleLowerCase();
      for (let index = 0; index < storeData.length; index++) {
        const element = storeData[index];
        if (element.city.toLocaleLowerCase().includes(value) || element.state.toLocaleLowerCase().includes(value) || element.store_name.toLocaleLowerCase().includes(value)) {
          storeHtml += this.blockHtml(element);
        }
      }
      let storeWrapper = qs('.stores-js', parent);
      if (storeHtml == '') {
        storeWrapper.innerHTML = "<p>There is no store around location</p>";
      } else {
        storeWrapper.innerHTML = storeHtml;
      }
    }
  
    blockHtml = (data) => {
      let rHtml = '';
      if (!data) {
        return rHtml;
      }
      rHtml = `<div class="block">
        <div class="block-wrapper">
          <div class="block-inner">
            <h3 class="store-name">
              <span>${data.store_name}<span>
            </h3>
            <p class="address">${data.address}</p>
            <a target="_blank" href="${data.map_location}" class="map-store-directions btn-primary text-12">Go to Location</a>
          </div>
        </div>
      </div>`;
      return rHtml;
    }
  
    init = async () => {
      await this.fetchUserLocation();
      await this.fetchStores();
      this.clickEvent();
    }
  
  }
  new StoreLocator(qs(".store-locator-section-js"));
  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      new StoreLocator(qs(".store-locator-section-js"));
    });
  }